import React, { useState, useEffect } from "react";
import { generateClient } from "aws-amplify/data";
import { list, getUrl } from "aws-amplify/storage";
import { BookViewer } from "../../components/shared";
import { Libros } from "../../components/shared";
import { fetchAuthSession } from "aws-amplify/auth";
import Modal from "react-modal";

const client = generateClient();

const getStoragePath = (value) => {
  if (!value.startsWith("http")) return value;
  return decodeURIComponent(new URL(value).pathname.slice(1));
};

async function pickAuthMode() {
  try {
    const s = await fetchAuthSession();
    return s.tokens ? "userPool" : "identityPool";
  } catch {
    return "identityPool";
  }
}

export default function LibrosDisplay() {
  const [libros, setLibros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isBookViewerOpen, setBookViewerOpen] = useState(false); // Estado para el modal
  const [selectedBookPages, setSelectedBookPages] = useState([]); // Estado para las páginas del libro

  useEffect(() => {
    const fetchLibros = async () => {
      try {
        const authMode = await pickAuthMode();
        // Obtener datos desde AppSync (forzar Identity Pool para lecturas públicas)
        const { data: items, errors } = await client.models.Libro.list({
          authMode,
        });
        if (errors && errors.length) {
          console.error("Errores GraphQL al listar Libros:", errors);
        }
        if (items.length > 0) {
          const formattedLibros = await Promise.all(
            items
              .sort((a, b) =>
                (a.pagesFolder || "").localeCompare(b.pagesFolder || ""),
              )
              .map(async (libro) => {
                // Obtener las URLs de las páginas del libro
                const folderPath = libro.pagesFolder.endsWith("/")
                  ? libro.pagesFolder
                  : `${libro.pagesFolder}/`;

                const filesResult = await list({
                  path: `libros/${folderPath}`,
                });

                const files = Array.isArray(filesResult.items)
                  ? filesResult.items
                  : [];

                const pageUrls = await Promise.all(
                  files
                    .filter((item) => item.path.match(/\.(jpg|jpeg|png|gif)$/i))
                    .map(async (item) => {
                      const urlResult = await getUrl({ path: item.path });
                      return urlResult.url.href;
                    }),
                );
                const { url: coverUrl } = await getUrl({
                  path: getStoragePath(libro.image),
                });

                return {
                  name: libro.name,
                  image: coverUrl.href,
                  pages: pageUrls, // Páginas del libro
                };
              }),
          );
          setLibros(formattedLibros);
        }
      } catch (error) {
        console.error("Error al obtener los datos de libros:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLibros();
  }, []);

  const handleProductClick = (product) => {
    setSelectedBookPages(product.pages); // Establece las páginas del libro seleccionado
    setBookViewerOpen(true); // Abre el modal
  };

  const closeBookViewer = () => {
    setBookViewerOpen(false);
  };

  if (loading) return <div>Cargando libros...</div>;

  return (
    <div>
      <Libros
        products={libros}
        text="Librería Virtual"
        onProductClick={handleProductClick}
      />

      {/* Modal para el visor de libros */}
      <Modal
        isOpen={isBookViewerOpen}
        onRequestClose={closeBookViewer}
        contentLabel="Visor de Libro"
        style={{
          overlay: { backgroundColor: "rgba(0, 0, 0, 0.75)", zIndex: 1000 },
          content: {
            width: "80vw", // Ancho del 80% de la ventana
            height: "90vh", // Altura del 90% de la ventana
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            padding: "0",
            border: "none",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        {/* Botón Cerrar fijo encima del visor */}
        <div style={{ position: "relative" }}>
          <button
            onClick={closeBookViewer}
            className="absolute right-2 top-2 z-50 rounded bg-red-600 px-3 py-1 font-bold text-white"
            style={{ zIndex: 1001 }}
          >
            Cerrar
          </button>
          <BookViewer pages={selectedBookPages} />
        </div>
      </Modal>
    </div>
  );
}
